import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const NavContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 12,
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  gap: 16,
  backgroundColor: theme.palette.secondary.main,
  borderRadius: 40,
  padding: "8px 16px",
  boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
  zIndex: 4,
  "& button": {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 32,
    padding: "8px 16px",
    fontSize: 14,
    cursor: "pointer",
    color: theme.palette.common.white,
    textTransform: "none",
    display: "flex",
    gap: 10,
    "& svg": {
      fill: theme.palette.common.white,
      width: '24px',
      height: '24px',
    },
    "&.selected": {
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.primary.main,
      "& svg": {
        fill: theme.palette.primary.main,
      },
    },
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.primary.main,
      "& svg": {
        fill: theme.palette.primary.main,
      },
    },
    "&:focus": {
      outline: "none",
    },
  },
}));
